// constants/config.js

export const API_BASE_URL = "https://api.formaxpay.com/recharge_pos/";
//export const API_BASE_URL = "http://192.168.1.2:5001/recharge_pos/";
